const dataStepSwapWaste = [
  {
    category: "1.Kategorikan Sampah",
    info: "Sampah harus dipilah menurut jenisnya, ditempatkan secara terpisah dalam kantong plastik atau wadah lainnya.",
  },
  {
    category: "2.Hitung Berat Sampah",
    info: "Menghitung berat sampah yang akan ditukar atau dapat memperkirakan berat sampah yang akan ditukar.",
  },
  {
    category: "3.Isi Form Tukar Sampah",
    info: "Anda dapat mengisi formulir yang telah kami siapkan. Anda harus memasukkan alamat pengambilan dan data sampah.",
  },
  {
    category: "4.Tunggu penjemputan",
    info: "Menunggu tim kami mengambil sampah yang telah anda siapkan untuk ditukarkan. ",
  },
  {
    category: "5.Mengecek Pengukuran",
    info: "Anda bisa mengecek kesesuaian timbangan sampah yang akan dilakukan tim kami. Kontrol ini dimaksudkan untuk memastikan transparansi pengukuran.",
  },
  {
    category: "6.Tunggu Pembayaran",
    info: "Setelah pengambilan dan pengukuran selesai, Anda dapat menunggu pembayaran dikreditkan secara otomatis ke akun Anda.",
  },
];

export default dataStepSwapWaste;
